export default __webpack_public_path__ + "static/media/banner.456fb71f.jpg";